module.exports = __webpack_public_path__ + "img/solarPanels_offline.d7ab7817.png";